import { useEffect } from "react";
import { useAppSelector } from "../../hooks";
import { sseModule } from "../../store";
import { authSelectors } from "../auth";
import { chatSelectors } from "../chat";

const { selectAccess, selectUserId } = authSelectors;
const { selectChatId } = chatSelectors;

export const useSSE = () => {
  const { token } = useAppSelector(selectAccess);
  const userId = useAppSelector(selectUserId);
  const chatId = useAppSelector(selectChatId);
  const isTabVisible = document.visibilityState === "visible";

  useEffect(
    () => () => {
      sseModule.disconnect();
    },
    []
  );

  useEffect(() => {
    const shouldReconnectSSE =
      isTabVisible && !sseModule.getIsActive() && token;

    const shouldConnect = userId && chatId && token;

    if (shouldReconnectSSE || shouldConnect) {
      sseModule.connect();
    }
  }, [isTabVisible, token, userId, chatId]);
};
